const barCodeValidator = (value: string | null | undefined): string => {
  if (!value) {
    return "";
  }
  const isValid = /^\d{13}$/.test(value);
  if (!isValid) {
    return "error.barCode";
  }

  return "";
};
export default barCodeValidator;
